export const hasCommerceIntent = () => {
  // note that this may have to be migrated to cash-frontend-service if we want the commerce intent to be reflected
  // prior to the UI rendering (e.g. in the login flow serverside.) Right now it assumes we're in the login flow, with the
  // grant flow redirect present in the URL
  const redirect = new URLSearchParams(window.location.search).get('redirect')
  return !!redirect && (redirect.startsWith('/account/grant-flow') || redirect.startsWith('/grant-flow'))
}

export const hasOONIntent = () => {
  return window.context === 'OON_P2P'
}

export const hasLocalIntent = () => {
  if (window.context !== 'CASH_LOCAL') {
    return false
  }

  const redirectSearchParamKey = Array.from(new URLSearchParams(window.location.search).keys()).find(
    key => key === 'redirect_to'
  )

  if (redirectSearchParamKey) {
    return false
  }

  return true
}

export const optionalScopeHeaders = () => {
  if (hasOONIntent()) {
    return { 'x-web-scope': 'oon' }
  } else if (hasCommerceIntent()) {
    return { 'x-web-scope': 'ap_checkout' }
  } else if (hasLocalIntent()) {
    return { 'x-web-scope': 'local' }
  }

  return undefined
}
